module.exports = __webpack_public_path__ + "static/media/logo.244c9478.svg";